/**
 * Created by lihanying on 2017/6/30.
 */
import React from 'react'
import { Table, Input, DatePicker, message, Select, Button, Spin } from 'antd'
import moment from 'moment'
import NineAndZeroRadio from '../../../components/nineAndZeroRadio'
import { changeStringTime, changeToDecimal } from '../../../util'
const { RangePicker } = DatePicker
const Option = Select.Option

export default class extends React.Component {
  state = {
    start_time: moment().format('YYYY-MM-DD'),
    end_time: moment().format('YYYY-MM-DD'),
    wallet_id: '',
    loading: true,
    radioValue: 2,
    rangeExceed: false,
  }

  componentDidMount() {
    this.props.fetchClubWalletList().then((res) => {
      this.setState({ loading: false })
    })
  }

  onChange = (value, dateString) => {
    this.setState({
      start_time: dateString[0],
      end_time: dateString[1],
      rangeExceed: false,
    })
    if (value && value[0] && value[1]) {
      const diff = moment(value[1]).diff(moment(value[0]), 'days')
      if (diff > 62) {
        message.warning('选取时段不能超过62天')
        this.setState({ rangeExceed: true })
        return
      }
    }
  }

  onSubmit = () => {
    const { start_time, end_time, radioValue } = this.state
    if (start_time.length !== 0 && end_time.length !== 0) {
      this.setState({ loading: true })
      this.props
        .fetchClubSearchStream({
          start_time: moment(start_time).format('YYYY-MM-DD HH:mm:ss'),
          end_time: moment(end_time).format('YYYY-MM-DD HH:mm:ss'),
          wallet_id: sessionStorage.getItem('wallet_id') || '',
          statisticType: radioValue,
        })
        .then((res) => {
          this.setState({ loading: false })
        })
      setTimeout(() => {
        sessionStorage.removeItem('wallet_id')
      }, 1000)
    } else {
      message.info('请选择时间')
    }
  }
  //导出报表
  clickDownload = (columns, list) => {
    if (!list) {
      return
    }
    let str = [],
      title = []
    columns.map((item) => {
      title.push(item.title)
    })
    str.push(title.join(','))
    for (let i = 0; i < list.length; i++) {
      let temp = []
      for (let j = 0; j < columns.length; j++) {
        temp.push(list[i][columns[j].dataIndex])
      }
      str.push(temp.join(','))
    }
    str = encodeURIComponent(str.join('\n'))
    return 'data:text/csv;charset=utf-8,\ufeff' + str
  }

  onTypeEvent = (type) => {
    this.setState({
      radioValue: type,
    })
  }

  render() {
    const { list, walletList } = this.props
    const columns = [
      {
        title: '流水id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '钱包名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '昵称',
        dataIndex: 'member_name',
        key: 'member_name',
      },
      {
        title: '电话',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '期初金额[元]',
        dataIndex: 'inits',
        key: 'inits',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '收入金额[元]',
        dataIndex: 'incomes',
        key: 'incomes',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '支出金额[元]',
        dataIndex: 'outcomes',
        key: 'outcomes',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '余额[元]',
        dataIndex: 'balances',
        key: 'balances',
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '操作时间',
        dataIndex: 'utime',
        key: 'utime',
        sorter: (a, b) => new Date(a.utime) - new Date(b.utime),
      },
      {
        title: '交易订单号',
        dataIndex: 'serial_number',
        key: 'serial_number',
      },
      {
        title: '备注',
        dataIndex: 'note',
        key: 'note',
      },
    ]

    const data =
      list.list &&
      list.list.map((item) => {
        item.inits = item.init / 100
        item.incomes = item.income / 100
        item.outcomes = item.outcome / 100
        item.balances = item.balance / 100
        return item
      })

    const { start_time, end_time } = this.state
    let reportName = sessionStorage.getItem('reportName')
    if (start_time.length !== 0 && end_time.length !== 0) {
      reportName += `${changeStringTime(start_time)}-${changeStringTime(
        end_time
      )}`
    }

    return (
      <div>
        <div style={{ marginBottom: '1rem' }}>
          <RangePicker
            format="YYYY-MM-DD"
            placeholder={['开始时间', '结束时间']}
            value={
              start_time
                ? [
                  moment(start_time, 'YYYY-MM-DD'),
                  moment(end_time, 'YYYY-MM-DD'),
                ]
                : null
            }
            onChange={this.onChange}
          />
          <NineAndZeroRadio typeEvent={this.onTypeEvent} />
          {walletList.list.length > 1 && (
            <Select
              style={{ width: 200, marginTop: '1rem', display: 'block' }}
              placeholder="选择钱包,可以不选择"
              onChange={(value) => sessionStorage.setItem('wallet_id', value)}
            >
              <Option value="">全部</Option>
              {walletList.list &&
                walletList.list.map((item, idx) => {
                  return (
                    <Option value={item.id} key={idx + 1}>
                      {item.name}
                    </Option>
                  )
                })}
            </Select>
          )}
          <Button
            type="primary"
            disabled={this.state.rangeExceed}
            onClick={() => this.onSubmit()}
            style={{ marginTop: '1rem', display: 'block' }}
          >
            查询
          </Button>
          <Button style={{ marginTop: '1rem' }}>
            <a
              id="test"
              href={this.clickDownload(columns, data ? data : [])}
              download={`${reportName}.csv`}
            >
              导出
            </a>
          </Button>
        </div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Table rowKey="id" bordered columns={columns} dataSource={data} />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubStream/component/stream.js